import uuidv4 from 'uuid/v4'

export const genId = (length) =>
  '-'.repeat(length || 8).replace(/-/g, () => ((Math.random() * 16) | 0).toString(16).toUpperCase())

export const generateRandomHash = (length=8) => uuidv4().replace(/-/g, '').slice(0, length)
